import * as jsxRuntime from "/home/runner/work/emea-ecodesign-wizard-hub/emea-ecodesign-wizard-hub/client/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment